import { withJsonFormsControlProps } from "@jsonforms/react";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { GlobalConfigContext } from "../../../context/GlobalConfigContext";
import { getTranslatedText } from "../../../utils/commons";
import DatePickerMaterialUIField from "./DatePickerMaterialUIField";

const DatePickerMaterialUIComponent = (props) => {
  const {
    handleChange,
    label,
    data,
    path,
    errors,
    schema,
    uischema,
    required,
    visible,
    enabled,
  } = props;
  const { t } = useTranslation();
  const {
    globalState: { programConfig },
  } = useContext(GlobalConfigContext);
  const currentProgramTimezone = programConfig?.localization?.programTimezone;

  const updateValue = (newVal) => {
    const timestampValue = newVal ? new Date(newVal).getTime() : undefined;
    handleChange(path, uischema.timestamp ? timestampValue : newVal);
  };

  return (
    <DatePickerMaterialUIField
      value={data}
      label={getTranslatedText(t, label, label)}
      updateValue={updateValue}
      errors={errors}
      schema={schema}
      uiSchema={uischema}
      required={required}
      visible={visible}
      disabled={!enabled || uischema?.disabled}
      readOnly={uischema?.readOnly}
      timezone={currentProgramTimezone}
      setToEndOfDay={uischema?.setToEndOfDay}
      setToStartOfDay={uischema?.setToStartOfDay}
      disableFutureDates={uischema?.disableFutureDates}
    />
  );
};

export const DatePickerMaterialUIControl = withJsonFormsControlProps(
  DatePickerMaterialUIComponent
);
